import {useQueryParams} from '@aboutyou/router';
import {useRef} from 'react';

import {
  GRIPS_DEVICE_ANDROID_APP,
  GRIPS_DEVICE_IOS_APP,
  GRIPS_DEVICE_PARAM,
} from '../features/Checkout/constants';

export const useDeviceQueryParam = () => {
  const queryParams = useQueryParams();
  // make sure this value never changes after it was set on first mount so that the banner does not pop in when the user navigates
  const deviceParam = useRef(queryParams.get(GRIPS_DEVICE_PARAM) || '');

  return [GRIPS_DEVICE_IOS_APP, GRIPS_DEVICE_ANDROID_APP].includes(
    deviceParam.current,
  );
};
